import React from 'react';
import { sendChatComposerFourthDimensionLead } from '../../../../redux/leadModalActions.js';
import GenericLeadSyncComposer from '../GenericLeadSyncComposer.js';

const FourthDimensionAddPatientComposer = () => {
  return <GenericLeadSyncComposer id={'fourth-dimension'} title={'4th Dimension'} syncMethod={sendChatComposerFourthDimensionLead} />;
};

export default FourthDimensionAddPatientComposer;
